<template>
    <div>
        <div class="ex-bg-pink" :class="{'ex-bg-white': isShownLink == false}">
            <div class="tour-num pt-0 pl-0 pr-0">
                <tour-info :tourInfoProp="tourInfo"></tour-info>
                <div class="error-message" v-if="errorMessage" style="margin: 5px 25px;">
                    <div class="d-flex">
                        <i class="icon-warning mr-2"></i>
                        <div class="errror-txt">
                            <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                            <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                        </div>
                    </div>
                </div>
                <div v-if="isShownCash" class="block-cnt">
                    <div class="heading-box">{{$t('cash.select_from_list')}}</div>
                    <InputT
                        v-if="utils.isCooperator()"
                        v-model="selectedInputT"
                        style="margin: 0 auto; width: auto;"
                    />
                    <div class="scroll-list">
                        <div v-for="(element, index) in ownListCash" :key="'key' + index" class="table-detail">
                            <div
                                v-if="selectedInputT.id === 1 && utils.isCooperator()"
                                class="detail-block"
                                :class="{'ex-block-heading': activeCash === index}"
                                @click="clickCash(element.carrying_prepayment_item_id, index, element.name)"
                                name="index"
                            >
                                <div class="block-row">
                                    <label class="row-lb">{{$t('cash.name')}}</label>
                                    <div class="row-cnt">{{element.name}}</div>
                                </div>
                                <div class="block-row">
                                    <label class="row-lb">{{$t('cash.period')}}</label>
                                    <div class="row-cnt">
                                        {{dateUtils.formatDateYYYYMMDD(element.days_from)}}({{dateUtils.getDay(element.days_from)}})〜
                                        <br />
                                        {{dateUtils.formatDateYYYYMMDD(element.days_to)}}({{dateUtils.getDay(element.days_to)}})
                                    </div>
                                </div>
                                <div class="block-row">
                                    <label class="row-lb">{{$t('cash.total_amount_sp')}}</label>
                                    <div
                                        class="row-cnt"
                                    >{{utils.formatPrice(element.total_deposit, currency_id)}}{{getCurrencyName(currency_id)}}</div>
                                </div>
                                <div class="block-row">
                                    <label class="row-lb">{{$t('cash.notice_c')}}</label>
                                    <div class="row-cnt">{{element.notice_c}}</div>
                                </div>
                            </div>
                        </div>

                        <div v-for="(element, index) in listCash" :key="index" class="table-detail">
                            <div
                                v-if="selectedInputT.id === 2 || !utils.isCooperator()"
                                class="detail-block"
                                :class="{'ex-block-heading': activeCash === index}"
                                @click="clickCash(element.carrying_prepayment_item_id, index, element.name)"
                                name="index"
                            >
                                <div class="block-row">
                                    <label class="row-lb">{{$t('cash.name')}}</label>
                                    <div class="row-cnt">{{element.name}}</div>
                                </div>
                                <div class="block-row">
                                    <label class="row-lb">{{$t('cash.period')}}</label>
                                    <div class="row-cnt">
                                        {{dateUtils.formatDateYYYYMMDD(element.days_from)}}({{dateUtils.getDay(element.days_from)}})〜
                                        <br />
                                        {{dateUtils.formatDateYYYYMMDD(element.days_to)}}({{dateUtils.getDay(element.days_to)}})
                                    </div>
                                </div>
                                <div class="block-row">
                                    <label class="row-lb">{{$t('cash.total_amount_sp')}}</label>
                                    <div
                                        class="row-cnt"
                                    >{{utils.formatPrice(element.total_deposit, currency_id)}}{{getCurrencyName(currency_id)}}</div>
                                </div>
                                <div class="block-row">
                                    <label class="row-lb">{{$t('cash.notice_c')}}</label>
                                    <div class="row-cnt">{{element.notice_c}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="isShownButton" class="mt-3 d-flex justify-content-center pl-25 pr-25">
                    <div class="row no-gutters w-100 justify-content-center">
                        <div class="col-6 pr-2">
                            <button
                                @click="isShownLink = true"
                                class="btn btn-white-44 w-100 fs-18"
                            >{{$t('button.after_certi')}}</button>
                        </div>
                        <div class="col-6 pl-2" v-if="isShownCashButton">
                            <button
                                @click="clickCashButton"
                                class="btn btn-pink-44 w-100 fs-18"
                            >{{$t('voucher.general.create_detail')}}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isShownLink" class="box-bottom-pink">
                <div class="btns-box">
                    <ul class="lst-btns">
                        <li v-if="!utils.isCooperator()">
                            <a
                                @click="toVoucherByGroup(constants.GroupVoucherType.invoice_bill)"
                                class="btn btn-white-38 ex-has-icon"
                            >
                                {{$t('voucher.group.invoice_bill')}}
                                <i class="icon-triangle-orange"></i>
                            </a>
                        </li>
                        <li v-if="!utils.isCooperator()">
                            <a
                                @click="goSelectContract()"
                                class="btn btn-white-38 ex-has-icon"
                            >
                                {{$t('voucher.group.contract')}}
                                <i class="icon-triangle-orange"></i>
                            </a>
                        </li>
                        <li>
                            <a
                                @click="toVoucherByGroup(constants.GroupVoucherType.local_expense_voucher)"
                                class="btn btn-white-38 ex-has-icon"
                            >
                                {{$t('voucher.group.local_expense_voucher')}}
                                <i class="icon-triangle-orange"></i>
                            </a>
                        </li>
                        <li v-if="!utils.isCooperator()">
                            <a
                                @click="toVoucherByGroup(constants.GroupVoucherType.other)"
                                class="btn btn-white-38 ex-has-icon"
                            >
                                {{$t('voucher.group.other')}}
                                <i class="icon-triangle-orange"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CashManagementService from "@/services/module/cash.service";
import TourManagementService from "@/services/module/tour.service";
import StorageService from "@/services/common/storage.service";
import { AuthService } from "@/services/common/auth.service";
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';
import { Constants } from "@/helpers/constants";
import TourInfo from "@/views/components/sp/Tour/Info";
import  InputT  from "@/views/components/pc/Tour/InputT"
export default {
    name: "SpAfterInputTour",
    components: {
    TourInfo,
    InputT,
},
    data () {
        return {
            utils: Utils,
            dateUtils: DateUtils,
            constants: Constants,
            isShownLink: false,
            ownListCash: [],
            listCash: [],
            isShownCash: false,
            isShownCashButton: false,
            isShownButton: true,
            activeCash: "",
            cashId: "",
            currency_id: Constants.JPY.id,
            errorMessage: "",
            selectedInputT: Constants.InputT[0],
            userCashKeyName: "",
            tourInfo: {},
            isClosed: 0,
            isNotTour: false,
        };
    },
    computed: {},
    created () {
        this.$emit("enableButton");
        this.$emit("update:actionHandler", () => {});
        this.userCashKeyName = StorageService.getUserCashKeyName();
        if (Utils.isCooperator()) {
            this.tourNumber = this.$route.query.search;
            this.getTourInfo(this.tourNumber, this.isClosed);
            this.getCashInfo(this.tourNumber);
            this.isShownCash = true;
            this.clickCashButton();
        } else {
            let tourInfo = JSON.parse(StorageService.getTour());
            this.getCashInfo(tourInfo.tour_number);
        }
        StorageService.clearPreInputVoucher();
    },
    mounted () {},
    methods: {
        setErrorMessage (msg) {
            this.errorMessage = msg;
        },
        getCurrencyName (id) {
            let name = Utils.getCurrencyName(id);
            return name;
        },
        getTourInfo (tourNumber, isClosed) {
            let _this = this;
            if (tourNumber) {
                TourManagementService.getTour(tourNumber, isClosed).then((response => {
                    this.tourInfo = response.data;
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if (response.status != 200) {
                        let errorCode = Utils.getErrorCode(response);
                        if (response.status == 404) {
                            _this.isNotTour = true;
                        } else {
                            _this.isNotTour = false;
                        }
                        if (errorCode) {
                            _this.setErrorMessage(
                                _this.$root.$t("error.error_code_" + errorCode)
                            );
                            _this.tourInfo = {};
                        }
                    } else {
                        if (!Utils.isEmptyObj(response.data)) {
                            _this.setErrorMessage("");
                            _this.tourInfo = response.data;
                            _this.getCashInfo(response.data.tour_number);
                        } else {
                            _this.setErrorMessage("");
                            _this.tourInfo = {};
                            // let msg = this.$root.$t("general.no_data");
                            // this.$toasted.success(msg, {});
                        }
                    }
                }))
            } else {
                this.setErrorMessage(
                    this.$root.$t("error.error_code_13")
                );
            }
        },
        getCashInfo (tourNumber) {
            let _this = this;
            CashManagementService.getCash(tourNumber).then(function (response) {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    _this.isShownCashButton = false;
                    let errorCode = Utils.getErrorCode(response);
                    if (errorCode) {
                        _this.setErrorMessage(
                            _this.$root.$t("error.error_code_" + errorCode)
                        );
                        _this.listCash = [];
                        _this.ownListCash = [];
                    }
                } else {
                    _this.isShownCashButton = true;
                    if (!Utils.isEmptyObj(response.data)) {
                        _this.setErrorMessage("");
                        _this.listCash = response.data;
                        _this.ownListCash = _this.listCash.filter(item => item.key_name == _this.userCashKeyName);
                    } else {
                        _this.setErrorMessage("");
                        _this.listCash = [];
                        _this.ownListCash = [];
                    }
                }
            });
        },
        toVoucherByGroup (groupType) {
            this.$router.push("/voucher/list?groupType=" + groupType);
        },
        goSelectContract () {
            this.$router.push("/voucher/selectContract");
        },
        clickCash (cashId, index, name) {
            this.activeCash = index;
            this.cashId = cashId;
            StorageService.saveCashName(name);
            StorageService.saveCashKeyName(this.listCash[index].key_name);
            const developerName = this.listCash[index].developer_name;
            StorageService.saveDeveloperName(developerName);
        },
        clickCashButton () {
            this.isShownCash = true;
            this.isShownButton = false;
            this.isShownLink = false;
            this.$emit("update:backHandler", () => {
                this.handleBackButton();
            });
            this.$emit("enableButton", this.$t("button.ok"));
            this.$emit("update:actionHandler", () => {
                if (this.cashId) {
                    StorageService.saveCashId(this.cashId);
                    this.$router.push({
                        path: "/voucher/list",
                        query: { screenType: Constants.CashScreenType },
                    });
                }
            });
            StorageService.removeCurrencyId();
        },
        handleBackButton () {
            this.isShownCash = false;
            this.isShownButton = true;
            this.$emit("enableButton");
            if (!Utils.isCooperator()) {
                this.$emit("update:actionHandler", () => {});
                this.$emit("update:backHandler", () => {
                    this.$router.go(-1);
            });
            }
        },
        setErrorMessage (msg) {
            this.errorMessage = msg;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Tour/AfterInput.vue